import { render } from "./qxc-ac.vue?vue&type=template&id=c85e17d4&scoped=true"
import script from "./qxc-ac.vue?vue&type=script&lang=js"
export * from "./qxc-ac.vue?vue&type=script&lang=js"

import "./qxc-ac.vue?vue&type=style&index=0&id=c85e17d4&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85e17d4"]])

export default __exports__